import { z } from "zod";
const attributeBool = z.preprocess((arg) => {
  if (typeof arg === "string") {
    if (arg === "false" || arg === "off") return false;
    return true;
  }
  return arg;
}, z.boolean());
const attributesCodeBlockSchema = z.object({
  lang: z.string(),
  title: z.string().optional(),
  maxHeight: z.string().optional(),
  minHeight: z.string().optional(),
  lineNumbers: attributeBool.optional(),
  lineNumberStart: z.coerce.number().optional(),
  highlight: z.string().default("").optional(),
  focus: z.string().default("").optional(),
  added: z.string().default("").optional(),
  removed: z.string().default("").optional(),
  fullHeight: attributeBool.optional(),
  id: z.string().optional()
});
export {
  attributesCodeBlockSchema
};
//# sourceMappingURL=attributes.js.map
